/**
 * Created by tong on 2018/1/30.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    Button,
    Upload,
    Icon,
    Modal,
    message,
} from 'antd';
import {
    hashHistory,
    withRouter,
} from 'react-router';
import {
    DmsTab,
    TableView,
    AdvanceFormNew,
} from 'Components';
import {
    list2,
    getListSelect,
    deleteSecondCustomer
} from '../../service/customer';
import {sKeylist} from '../../service/dictionary/dataitem';
import {allChildren} from '../../service/zone';
import {
    Store,
    Actions,
    customerTypeMap,
} from './store';
import {
    downLoadTemplate,
    toImportExcel,
    config,
    objectSerial,
    showSpin,
    hideSpin,
} from 'Utils';

const confirm = Modal.confirm;

class CustomerList extends React.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            filterBoxVisible: false,
            options: [],
            channels: [],
            channel_type: [],
            channel_rank: [],
            rows: [],
            total: 0,
            searchObj: {
                code: '',
                name: '',
                phone: '',
                eareCode: '',
                status: '',
                s: 10,
                p: 1,
            },
            selectedRowKeys: [],
            button_limits_end: {},
            loading: true,
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.downloadChange = this.downloadChange.bind(this);
        this.importChange = this.importChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.deleteHandle = this.deleteHandle.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'channel' && path[2] !== 'add') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
        }
    }

    componentWillMount() { //准备数据
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                },
            });
        }
        allChildren({id: 0}).then(res => { //归属区域
            if (res.data && res.data.length > 0) {
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({options: res.data});
                    }
                }, 0);
            }
        });
        getListSelect().then(res => { //上级渠道
            if (res.data && res.data.length > 0) {
                const data = res.data.map((x, index) => {
                    return {
                        ...x,
                        value: x.id,
                        text: x.name,
                    };
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channels: data});
                    }
                }, 0);
            }
        });
        sKeylist({sKey: 'channel_rank'}).then(res => { //渠道等级
            if (res.status) {
                let arr = res.data.map(x => {
                    return {
                        text: x.name,
                        value: x.sKey,
                    };
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_rank: arr});
                    }
                }, 0);
            }
        });
        sKeylist({sKey: 'channel_type'}).then(res => { //渠道类型
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: '',
                    },
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.sKey,
                    });
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_type: arr});
                    }
                }, 0);
            }
        });
    }

    componentDidMount() {
        this.mounted = true;
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(1);
    }

    /*导入*/
    importChange() {
        alert('导入');
    }

    /*筛选*/
    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        const self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                code: '',
                name: '',
                phone: '',
                eareCode: '',
                sortName: '',
                status: '',
                p: 1,
            }, loading: true,
        }, () => {
            self.getData();
        });
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {...this.state.searchObj, p: 1},
            loading: true,
        }, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        // console.log(name + ':\t' + value);
        if (name === 'lastOperationTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    lastOperationTimeStart: value.from,
                    lastOperationTimeEnd: value.end,
                },
            });
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    getData() {
        const self = this;
        const {searchObj} = this.state;
        list2(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                self.setState({loading: false});
            }
        });
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/employee/exportCustomerList?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    deleteHandle() {
        const self = this;
        const {selectedRowKeys} = this.state;
        if (!selectedRowKeys.length) {
            message.warn('请选择要删除的客户');
            return;
        }
        confirm({
            title: '确定要删除这些客户吗?',
            onOk() {
                showSpin();
                deleteSecondCustomer({ids: selectedRowKeys}).then(res => {
                    hideSpin();
                    self.setState({selectedRowKeys: []});
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && self.getData();
                });
            },
            onCancel() {
            },
        });
    }

    render() {
        const {rows, total, searchObj, button_limits_end, selectedRowKeys, loading} = this.state;
        console.log(this.state.searchObj);
        const filterBoxProps = {
            fileds: [
                {
                    name: 'code',
                    label: '客户编码',
                    text: '输入客户编码',
                    defaultValue: searchObj.code,
                    type: 'default',
                }, {
                    name: 'name',
                    label: '客户名称',
                    text: '输入客户名称',
                    defaultValue: searchObj.name,
                    type: 'default',
                    // },{
                    //     name:'cusType',
                    //     label: '客户类型',
                    //     type:'select',
                    //     defaultValue: searchObj.cusType,
                }, {
                    name: 'sortName',
                    label: '客户缩写',
                    text: '输入客户缩写',
                    defaultValue: searchObj.sortName,
                    type: 'default',
                    // },{
                    //     name:'cusType',
                    //     label: '客户类型',
                    //     type:'select',
                    //     defaultValue: searchObj.cusType,
                },
                {
                    label: '等级',
                    name: 'eareCode',
                    type: 'select',
                    text: '全部',
                    options: [
                        {value: 'A', text: 'A'},
                        {value: 'B', text: 'B'},
                        {value: 'C', text: 'C'},
                    ],
                    multiple: false,//支持多选
                    defaultValue: '全部',
                },
                {
                    name: 'phone',
                    label: '电话号码',
                    text: '输入电话号码',
                    defaultValue: searchObj.phone,
                    type: 'default',
                    // },{
                    //     name:'cusType',
                    //     label: '客户类型',
                    //     type:'select',
                    //     defaultValue: searchObj.cusType,
                },
                {
                    label: '状态',
                    name: 'status',
                    type: 'select',
                    text: '全部',
                    options: [
                        {value: '', text: '全部'},
                        {value: '1', text: '生效'},
                        {value: '0', text: '失效'},
                    ],
                    multiple: false,//支持多选
                    defaultValue: '全部',
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            rowSelection: {
                selectedRowKeys: selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => this.setState({selectedRowKeys}),
            },
            columns: [
                {
                    title: '客户编码',
                    dataIndex: 'code',
                    sorter: true,
                    // sorter: (a, b) => a.code.length - b.code.length,
                    // sortOrder: sortedInfo.columnKey === 'code' && sortedInfo.order,
                }, {
                    title: '客户缩写',
                    dataIndex: 'sortName',
                }, {
                    title: '客户名称',
                    dataIndex: 'name',
                    render: (text, record, index) => {
                        return <a href={`#/customer/${record.id}`}>{text}</a>;
                    },
                },
                {
                    title: '电话号码',
                    dataIndex: 'phone',
                },{
                    title: '收货人',
                    dataIndex: 'seller',
                }, {
                    title: '客户等级',
                    dataIndex: 'level',
                }, {
                    title: '客户类型',
                    dataIndex: 'cusType',
                    render: (text, record, index) => customerTypeMap[text] || '',
                }, {
                    title: '联系地址',
                    dataIndex: 'address',
                    render: (text, record, index) => {
                        return `${record.provinceText || ''}${record.cityText || ''}${record.countyText || ''}${text || ''}`;
                    },
                }, {
                    title: '客户状态',
                    dataIndex: 'status',
                    render: (text, record, index) => <span
                        style={{color: text == 1 ? '#00924c' : '#d73435'}}>{record.statusText}</span>,
                }, {
                    title: '创建时间',
                    dataIndex: 'createdDate',
                }, {
                    title: '审核状态',
                    dataIndex: 'accountStatus',
                    render: (text, record, index) => {
                        if (text === 0) {
                            return <span style={{color: '#d61518'}}>禁用</span>;
                        }
                        if (text === 2) {
                            return <span>待审核</span>;
                        }
                        if (text === 1) {
                            return <span style={{color: '#00924c'}}>启用</span>;
                        }
                    },
                },
            ],
            rows,
        };
        let uploadParam = toImportExcel(1, () => {
            this.getData();
        });
        return <div className="dms-body">
            <DmsTab options={[`客户管理`]} defaultKey={0}>
                {/* { button_limits_end.customer_list_01 &&  <Button onClick={this.downloadChange}>下载模板</Button>}
         { button_limits_end.customer_list_02 &&  <Button onClick={this.importChange}>导入</Button>}
         { button_limits_end.customer_list_03 && <Button icon="plus" onClick={this.goView.bind(this, `/customer/add/0`)}>新增</Button>} */}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {button_limits_end.customer_list_03 &&
                        <Button icon="plus"
                                style={{marginRight: 15}}
                                onClick={this.goView.bind(this, `/customer/add/0`)}>新增</Button>}
                    {
                        button_limits_end.customer_list_02
                        &&
                        <Upload {...uploadParam}>
                            <Button style={{marginRight: 15}}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                    }
                    {button_limits_end.customer_list_01 &&
                        <Button icon="download" style={{marginRight: 15}}
                                onClick={this.downloadChange}>下载模板</Button>}
                    <Button icon="export" style={{marginRight: 15}} onClick={this.exportChange}>导出</Button>
                    <Button icon="delete" onClick={this.deleteHandle}>删除</Button>

                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>;
    }
}
;
export default withRouter(CustomerList);



// WEBPACK FOOTER //
// ./src/routes/customer/list.js